export const ACCOUNT_SUMMARY_PATH = '/loyallist/accountsummary';
export const STAR_REWARDS_PATH = '/loyalty/starrewards';

export const LEGACY_HUB_REDIRECT_PATHS = [
  '/loyallist/pickyourdays',
  '/creditservice/marketing/benefits',
  '/loyallist',
  '/loyallist/enrollment',
  '/loyallist/accountassociation',
];

export function getAccountSummaryRedirectLocation(originalUrl) {
  const queryString = originalUrl.includes('?') ? originalUrl.slice(originalUrl.indexOf('?')) : '';

  return `${ACCOUNT_SUMMARY_PATH}${queryString}`;
}

export function getStarRewardsRedirectLocation(originalUrl) {
  const queryString = originalUrl.includes('?') ? originalUrl.slice(originalUrl.indexOf('?')) : '';

  return `${STAR_REWARDS_PATH}${queryString}`;
}
